import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Bell, CheckCheck } from "lucide-react";
import { api } from "@/lib/api";
import { AppLayout } from "@/components/AppLayout";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useI18n } from "@/contexts/I18nContext";

export default function Notifications() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  const fetchN = async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data);
    } catch (_) {}
  };
  useEffect(() => { fetchN(); }, []);

  const markAll = async () => {
    await api.post("/notifications/read-all");
    fetchN();
  };
  const markRead = async (id) => {
    await api.post(`/notifications/${id}/read`);
    fetchN();
  };

  return (
    <AppLayout>
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-display font-extrabold text-4xl tracking-tight">{t("notif.title")}</h1>
        <Button variant="outline" size="sm" onClick={markAll} data-testid="notif-markall-btn">
          <CheckCheck className="w-4 h-4 mr-1" /> {t("notif.markAllRead")}
        </Button>
      </div>

      <Card className="border-border">
        <CardContent className="p-0">
          {items.length === 0 ? (
            <div className="py-16 text-center text-muted-foreground text-sm">{t("notif.empty")}</div>
          ) : (
            <div className="divide-y divide-border">
              {items.map((n) => (
                <div key={n.notification_id}
                  className={`px-6 py-4 flex items-start gap-3 ${!n.read ? "bg-primary/5" : ""}`}
                  data-testid={`notif-${n.notification_id}`}>
                  <div className="w-9 h-9 rounded-lg bg-primary/10 text-primary flex items-center justify-center flex-shrink-0">
                    <Bell className="w-4 h-4" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <div className="font-medium">{n.title}</div>
                      <Badge variant="outline" className="text-[10px]">{n.type}</Badge>
                    </div>
                    <div className="text-sm text-muted-foreground mt-0.5">{n.body}</div>
                    <div className="text-xs text-muted-foreground mt-1">{new Date(n.created_at).toLocaleString()}</div>
                  </div>
                  {!n.read && (
                    <Button size="sm" variant="ghost" onClick={() => markRead(n.notification_id)}
                      data-testid={`notif-read-${n.notification_id}`}>
                      <CheckCheck className="w-4 h-4" />
                    </Button>
                  )}
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </AppLayout>
  );
}
